import React from 'react';

const Notification = () => {
  return (
    <div>
      <h3>Coming Soon...</h3>
    </div>
  );
};

export default Notification;
